export interface IProcedure
{
    id: number;
    code: string;
    description: string;
    codeSet: string;
    category: ICategory;
}


export interface ICategory
{
    id:number;
    categoryName: string;
}

export class Procedure implements IProcedure
{
    constructor
    (
        public id: number,
        public code: string,
        public description: string,
        public codeSet: string,
        public category: ICategory,
    )
    {

    }

    get displayName() : string
    {
        return this.code + ' - ' + this.description;
    }


    get limitedDescription() : string
    {
        if(this.description.length <= 50)
        {
            return this.description
        }
        else
        {
            return `${this.description.substring(0,50)}...`;
        }
    }
}


export interface IDiagnosis
{
    code:string;
    description: string;
}

export class Diagnosis implements IDiagnosis
{
    constructor
    (
        public code: string,
        public description: string
    )
    {}
    
    get limitedDescription() : string
    {
        if(this.description.length <= 50)
        {
            return this.description
        }
        else
        {
            return `${this.description.substring(0,50)}...`;
        }
    }
}


export interface IModifier
{
    code:string;
    description:string;
    modifierMeaning: number;
}

export class Modifier implements IModifier
{
    constructor
    (
        public code: string,
        public description: string,
        public modifierMeaning: number
    )
    {}

    get limitedDescription() : string
    {
        if(this.description.length <= 50)
        {
            return this.description
        }
        else
        {
            return `${this.description.substring(0,50)}...`;
        }
    }
}